import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ControlMessagesComponent } from './control-messages.component';
import { PhonePatternCountryValidatorDirective } from './phone-pattern-country-validator.directive';
import { BitlyValidatorDirective } from './validators';

const declarations = [ControlMessagesComponent, PhonePatternCountryValidatorDirective, BitlyValidatorDirective];
const exported = [...declarations];

@NgModule({
  imports: [CommonModule],
  exports: [...exported],
  declarations: [...declarations],
})
export class FormValidationModule {}
